import { Component, OnInit } from '@angular/core';
import {Constants} from '../../../../constants/ebtq-constants';
import {UtilityService} from '../../../../services/utility-service';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-purchasing-fee-reports',
  templateUrl: './purchasing-fee-reports.component.html',
  styleUrls: ['./purchasing-fee-reports.component.scss']
})
export class PurchasingFeeReportsComponent implements OnInit {


  feeTypes: any = [];
  sellerNumber:string;
  reportingStartDate: Date;
  reportingEndDate: Date;
  selectedFeeType:string;
  errorMessage: any[];
  errHeading: string;
  isExternal: boolean;
  reportingStartDateString: string;
  reportingEndDateString: string;
  sellerList: any = [];
  title = 'Adhoc Reports';

  constructor(private utilService:UtilityService, private titleService: Title) { }

  ngOnInit(): void {
    this.errHeading = Constants.ERROR_HEADER;
    this.errorMessage = [];
    this.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.titleService.setTitle(this.title);

    this.feeTypes.push({ label: 'Seasoned Loan Fees', value: 'Seasoned Loan Fees' });
    this.feeTypes.push({ label: 'Repurchase Fees', value: 'Repurchase Fees' });

    if (!this.isExternal) {
      this.feeTypes.push({label: 'Waivers', value: 'Waivers'});

    }
    else {
      if (this.isExternal)
      {
        if (sessionStorage.getItem('authServrList') != null) {
          this.sellerList = Array.from(JSON.parse(sessionStorage.getItem('sellerList')));
          this.sellerNumber = this.sellerList[0].value;
        }

      }
      /*if (sessionStorage.getItem('sellerList') != null) {
        let sellerNumberArray = Array.from(JSON.parse(sessionStorage.getItem('sellerList')));
        this.sellerNumber=(<any>sellerNumberArray[0]).value;

      }*/
    }

    this.selectedFeeType = 'Repurchase Fees';
  }

  onClear() {
    this.reportingStartDate = null;
    this.reportingEndDate = null;

  }


  validate() {
    this.errorMessage = [];

    if (this.sellerNumber == null || this.sellerNumber !== undefined
    || this.reportingStartDate == null || this.reportingStartDate === undefined
    ||  this.reportingEndDate == null || this.reportingEndDate === undefined)
    {
      this.errorMessage.push(Constants.SEARCH_CRYSTALRpt127);
    }
    if (this.sellerNumber != null && this.sellerNumber !== undefined && this.sellerNumber.length > 0)
    {
      if (isNaN(Number(this.sellerNumber)))
      {
        // this.errorMessage.push(Constants.SELLER_NUM_VALID);
        this.errorMessage.push(Constants.SELLER_LENGTH_VALID);
      }
      else if (this.sellerNumber.length !== 9)
      {
        this.errorMessage.push(Constants.SELLER_LENGTH_VALID);
      }
    }
    else {
      this.errorMessage.push(Constants.SELLER_LENGTH_VALID);
    }

    if (this.reportingStartDate == null || this.reportingStartDate === undefined)
    {
      this.errorMessage.push(Constants.EMPTY_REPORT_DATE);

    }
    if (this.reportingEndDate ==  null || this.reportingEndDate === undefined) {
      this.errorMessage.push(Constants.EMPTY_REPORT_DATE);


    }

  }

  submit() {

    if (this.reportingStartDate != null && this.reportingStartDate !== undefined)
    {
      this.reportingStartDateString = this.utilService.convertMillisecToDate(this.reportingStartDate);

    }
    if (this.reportingStartDate != null && this. reportingEndDate !== undefined)
    {
      this.reportingEndDateString = this.utilService.convertMillisecToDate(this.reportingEndDate);
    }

    console.log('seller:', this.sellerNumber);
    console.log('reporting start Date:', this.reportingStartDate);
    console.log('reporting End date:', this.reportingEndDate);
    this.validate();
  }

}
